import { useTranslation } from 'react-i18next';

import { InternationalPhoneField } from '@/components/phone/InternationalPhoneField';

interface CoursePurchasePhoneFieldProps {
  country: string;
  phone: string;
  onCountryChange: (country: string) => void;
  onPhoneChange: (phone: string) => void;
  disabled?: boolean;
}

export function CoursePurchasePhoneField({
  country,
  phone,
  onCountryChange,
  onPhoneChange,
  disabled = false,
}: CoursePurchasePhoneFieldProps) {
  const { t } = useTranslation();

  return (
    <InternationalPhoneField
      id="course-checkout-phone"
      label={t('checkout.whatsapp')}
      countryLabel={t('checkout.phoneCountry')}
      searchLabel={t('checkout.searchCountry')}
      notFoundLabel={t('checkout.noCountryFound')}
      placeholder={t('checkout.whatsappPlaceholder')}
      country={country}
      phone={phone}
      onCountryChange={onCountryChange}
      onPhoneChange={onPhoneChange}
      disabled={disabled}
    />
  );
}
